import React from "react";

export default function ReviewStars({ rating, starSize, starSpacing }) {
  // example values {rating: 4.6, starSize: '60px', starSpacing: '12px'}
  const style = {
    "--rating": rating,
    "--star-size": starSize,
    "--star-spacing": starSpacing,
  };
  return (
    <div
      className="Stars"
      style={style}
      aria-label={`Rating of this product is ${rating} out of 5.`}
    ></div>
  );
}
